module.exports = __webpack_public_path__ + "static/img/activity_sdy_03-1.6be4456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_03-1.jpg
// module id = sOlO
// module chunks = 0